import { isNil } from 'lodash';
import * as clientService from 'services/clientService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWRClientData = Awaited<ReturnType<typeof clientService.getClientAsync>>;

const useClient = (
  clientId: number,
  load = true
): SWRResponse<SWRClientData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_CLIENT_ENDPOINT, clientId] : null,
    async ([_, clientId]) => await clientService.getClientAsync(clientId)
  );

export const SWR_CLIENT_ENDPOINT = 'client';

export default useClient;
